import axios from 'axios'

// Staff support pages name the organization in the URL. Customers never supply a tenant selector.
// The API checks this parameter against persisted identity on every request.
export function companySupportOrganization() {
  return window.location.pathname.match(/^(?:\/manage)?\/company-support\/([0-9a-f-]{36})(?:\/|$)/i)?.[1]
}

export function companyUrl(url: string) {
  const organization = companySupportOrganization()
  return organization
    ? `${url}${url.includes('?') ? '&' : '?'}organization=${encodeURIComponent(organization)}`
    : url
}

const client = { ...axios }
for (const method of ['get', 'post', 'put', 'patch', 'delete'] as const) {
  client[method] = ((url: string, ...args: any[]) => (axios[method] as any)(companyUrl(url), ...args)) as any
}
export default client
